import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { withStyles } from '@material-ui/core/styles';
import { bindActionCreators } from 'redux';

import {
    TextField, Button,
} from '@material-ui/core';

import * as ProgramStore from '../../../../app/store/ProgramStore';

const styles = theme => ({
    content: {
        padding: theme.spacing(2),
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',

        [theme.breakpoints.down('xs')]: {
            overflowY: 'initial',
        },
    },
    actions: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    taskField: {
        marginBottom: theme.spacing(3),
    },
    addCustomButton: {
        marginLeft: theme.spacing(2),
    },
});

class AddCustomTask extends React.Component {
    state = {
        validationError: false,
        time: '12:00',
        name: '',
        description: '',
    }

    handleChange = name => (event) => {
        this.setState({ [name]: event.target.value });
    }

    save = () => {
        if (this.state.name) {
            const startTime = this.props.date;
            startTime.setHours(this.state.time.slice(0, 2), this.state.time.slice(3, 5), 0, 0);

            const elementToAdd = {
                patientProgramId: this.props.currentProgram.id,
                displayName: this.state.name,
                properties: {
                    description: this.state.description,
                },
                startTime,
            };

            this.props.insertPatientElement(elementToAdd, {
                callback: this.props.onClose,
                reducerParams: { patientProgramId: elementToAdd.patientProgramId },
            });
        } else {
            this.setState({ validationError: true });
        }
    }

    render() {
        const {
            classes, translate, disabled,
        } = this.props;

        return (
            <div className={classes.root}>
                <div className={classes.content}>
                    <TextField
                        label={translate('addTask.startAt')}
                        fullWidth
                        disabled={disabled}
                        type="time"
                        value={this.state.time}
                        onChange={this.handleChange('time')}
                        className={classes.taskField}
                    />

                    <TextField
                        label={translate('addTask.title')}
                        fullWidth
                        disabled={disabled}
                        value={this.state.name}
                        onChange={this.handleChange('name')}
                        className={classes.taskField}
                        error={this.state.validationError}
                    />

                    <TextField
                        label={translate('addTask.description')}
                        multiline
                        minRows={10}
                        fullWidth
                        disabled={disabled}
                        value={this.state.description}
                        onChange={this.handleChange('description')}
                        className={classes.taskField}
                    />
                </div>

                <div className={classes.actions}>
                    <Button color="primary" variant="contained" onClick={this.save} className={classes.addCustomButton}>
                        {translate('addTask.add')}
                    </Button>
                </div>
            </div>
        );
    }
}

AddCustomTask.propTypes = {
    translate: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    insertPatientElement: PropTypes.func.isRequired,
    currentProgram: PropTypes.object.isRequired,
    date: PropTypes.instanceOf(Date),
    disabled: PropTypes.bool,
    onClose: PropTypes.func,
};

AddCustomTask.defaultProps = {
    disabled: false,
    date: null,
    onClose: null,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    currentProgram: state.programStore.currentProgram,
});

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(ProgramStore.actionCreators, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddCustomTask));
